/** @format */

import axios from 'axios';
import { getAlert } from '../../util/alert';
import Constantes from '../../util/Constantes';

const SERVER = process.env.REACT_APP_SERVER_URL_UPNCORE;
const PATH_Attorney = Constantes().ApiConfig.PATH_LoginAttorney;
const PATH_MFA = Constantes().ApiConfig.PATH_MFA;
const PATH_Ubigeo = Constantes().ApiConfig.PATH_GetUbigeoValue;
const PATH_Save = Constantes().ApiConfig.PATH_UpdateProfileAttorney;
const ENDPOINTAttorney = `${SERVER}${PATH_Attorney}`;
const ENDPOINTMFA = `${SERVER}${PATH_MFA}`;
const ENDPOINTUbigeo = `${SERVER}${PATH_Ubigeo}`;
const ENDPOINTSave = `${SERVER}${PATH_Save}`;
const headers = Constantes().ApiConfig.headers;
const dataUser = JSON.parse(localStorage.getItem('userLogin'));
const API = {
  listarAttorney: async (objCodigo, alertMessage) => {
    try {
      let result = await axios.post(ENDPOINTAttorney, objCodigo, {
        headers: headers,
      });
      if (result.data.Status == 'NOK') {
        getAlert(Constantes().noDNI, '', alertMessage);
      } else if (result.data.detail.length == 0) {
        getAlert(Constantes().noRegistros, '', alertMessage);
      }
      return await result.data;
    } catch (err) {
      getAlert(
        Constantes().SeccionExpirada,
        process.env.REACT_APP_SERVER_URL_UPNHOSTBASE,
      );
    }
  },
  validarMFA: async (objMfa, alertMessage) => {
    try {
      let result = await axios.post(ENDPOINTMFA, objMfa, {
        headers: headers,
      });
      if (result.data.Status == 'NOK') {
        getAlert('Codigo incorrecto', '', alertMessage);
      }
      return await result.data;
    } catch (err) {
      console.log(err);
      getAlert(
        Constantes().SeccionExpirada,
        process.env.REACT_APP_SERVER_URL_UPNHOSTBASE,
      );
    }
  },
  listarUbigeo: async (objCodigo, alertMessage) => {
    try {
      let result = await axios.post(ENDPOINTUbigeo, objCodigo, {
        headers: headers,
      });
      if (dataUser == undefined) {
        getAlert(Constantes().msmUbigeo, Constantes().login, alertMessage);
      } else if (result.data.Status == 'NOK') {
        getAlert(result.data.message, '', alertMessage);
      } else if (result.data.detail == undefined) {
        getAlert(Constantes().msmUbigeo, '', alertMessage);
      } else if (result.data.detail.length == 0) {
        getAlert(Constantes().msmUbigeo, '', alertMessage);
      }
      return await result.data.detail;
    } catch (err) {
      getAlert(
        Constantes().SeccionExpirada,
        process.env.REACT_APP_SERVER_URL_UPNHOSTBASE,
      );
    }
  },
  Save: async (objCodigo, alertMessage) => {
    try {
      let result = await axios.post(ENDPOINTSave, objCodigo, {
        headers: headers,
      });
      if (dataUser == undefined) {
        getAlert(Constantes().msmNoGuardo, Constantes().login, alertMessage);
      } else if (result.data.Status == 'NOK') {
        getAlert(result.data.message, '', alertMessage);
      } else if (result.data.length == 0) {
        getAlert(Constantes().msmNoGuardo, '', alertMessage);
      }
      getAlert(Constantes().msmGuardo, '', alertMessage);
      return await result.data;
    } catch (err) {
      getAlert(
        Constantes().SeccionExpirada,
        process.env.REACT_APP_SERVER_URL_UPNHOSTBASE,
      );
    }
  },
};

export default API;
